import React, { useState } from "react";

const FAQ = () => {
    const [faqOpen, setFaqOpen] = useState({});

    const toggleFaq = (index) => {
        setFaqOpen(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };


    return <section id="faqs" className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
                <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">FAQs</h2>
            </div>

            <div className="space-y-4">
                {[
                    {
                        question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor odio non laoreet faucibus?",
                        answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor odio non laoreet faucibus. Nulla vitae ligula id diam gravida blandit id sed nibh. Nulla dolor felis, laoreet sit amet placerat quis, accumsan a enim."
                    },
                    {
                        question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor odio non laoreet faucibus?",
                        answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor odio non laoreet faucibus. Nulla vitae ligula id diam gravida blandit id sed nibh. Nulla dolor felis, laoreet sit amet placerat quis, accumsan a enim."
                    },
                    {
                        question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor odio non laoreet faucibus?",
                        answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor odio non laoreet faucibus. Nulla vitae ligula id diam gravida blandit id sed nibh. Nulla dolor felis, laoreet sit amet placerat quis, accumsan a enim."
                    },
                    {
                        question: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor odio non laoreet faucibus?",
                        answer: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tempor odio non laoreet faucibus. Nulla vitae ligula id diam gravida blandit id sed nibh. Nulla dolor felis, laoreet sit amet placerat quis, accumsan a enim."
                    }
                ].map((faq, index) => (
                    <div key={index} className="bg-white rounded-xl shadow-[0px_0px_6px_0px_#00000040]">
                        <button
                            className="w-full px-6 py-6 text-left flex items-center justify-between hover:bg-gray-50 rounded-xl"
                            onClick={() => toggleFaq(index)}
                        >
                            <span className="font-medium text-gray-900">{faq.question}</span>
                            <div className="flex items-center justify-center bg-[#56B22F] h-6 w-6 text-white pb-1 font-bold text-xl">
                                {faqOpen[index] ? '-' : '+'}
                            </div>
                            {/* <svg
                                className={`w-5 h-5 text-gray-500 transition-transform ${faqOpen[index] ? 'transform rotate-180' : ''}`}
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg> */}
                        </button>
                        {faqOpen[index] && (
                            <div className="px-6 pb-6">
                                <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    </section>;
};

export default FAQ;
